import { supertypeClass, property, Remoteable, Persistable, amorphicStatic } from '@haventech/amorphic';
import { IsomorphicPersistent } from '@hit/amorphic-types';
import { Agent } from '../customer/Agent';

@supertypeClass({ toClient: true, toServer: true })
export class AgentDefaultCommissionSplit extends IsomorphicPersistent {
  @property({ getType: () => Agent })
  primaryAgent: Agent;

  @property({ getType: () => Agent })
  additionalAgent: Agent;

  @property()
  ratio: number;

  @property()
  renewalCommissionRatio: number;

  constructor() {
    super();
  }

  static new(primaryAgent: Agent, additionalAgent: Agent, ratio: number, renewalCommissionRatio: number) {
    return new AgentDefaultCommissionSplit().init(primaryAgent, additionalAgent, ratio, renewalCommissionRatio);
  }

  init(primaryAgent: Agent, additionalAgent: Agent, ratio: number, renewalCommissionRatio: number) {
    //add default values for primary/additional agent ratios if ratio or rtr is null
    if (primaryAgent.producerId === additionalAgent.producerId) {
      this.ratio = typeof ratio === 'number' ? ratio : 100;
      this.renewalCommissionRatio = typeof renewalCommissionRatio === 'number' ? renewalCommissionRatio : 100;
    } else {
      this.ratio = ratio || 0;
      this.renewalCommissionRatio = renewalCommissionRatio || 0;
    }
    this.primaryAgent = primaryAgent;
    this.additionalAgent = additionalAgent;
    return this;
  }
}
